import { render, staticRenderFns } from "./ZonesPoint.vue?vue&type=template&id=fb2c849c&scoped=true&"
import script from "./ZonesPoint.vue?vue&type=script&lang=js&"
export * from "./ZonesPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2c849c",
  null
  
)

export default component.exports